export class ContactData{
	type: string
	name: string
	value: string
}


// WEBPACK FOOTER //
// ./src/app/models/contact-data.model.ts